<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '130px'">
          <el-form-item label="用户姓名" prop="leadsName">
          <el-input v-model="dataForm.leadsName" placeholder="用户姓名"></el-input>
      </el-form-item>
          <el-form-item label="手机号" prop="leadsTel">
          <el-input v-model="dataForm.leadsTel" placeholder="手机号"></el-input>
      </el-form-item>
          <el-form-item label="年龄" prop="age">
          <el-input v-model="dataForm.age" placeholder="年龄"></el-input>
      </el-form-item>
          <el-form-item label="page名字" prop="pageName">
          <el-input v-model="dataForm.pageName" placeholder="page名字"></el-input>
      </el-form-item>
          <el-form-item label="城市ID" prop="componentId">
          <el-input v-model="dataForm.componentId" placeholder="城市ID"></el-input>
      </el-form-item>
          <el-form-item label="城市名" prop="componentName">
          <el-input v-model="dataForm.componentName" placeholder="城市名"></el-input>
      </el-form-item>
          <el-form-item label="线索id" prop="leadsId">
          <el-input v-model="dataForm.leadsId" placeholder="线索id"></el-input>
      </el-form-item>
          <el-form-item label="广告点击id" prop="clickId">
          <el-input v-model="dataForm.clickId" placeholder="广告点击id"></el-input>
      </el-form-item>
          <el-form-item label="广告主id" prop="accountId">
          <el-input v-model="dataForm.accountId" placeholder="广告主id"></el-input>
      </el-form-item>
          <el-form-item label="账号类型" prop="accountType">
          <el-input v-model="dataForm.accountType" placeholder="账号类型"></el-input>
      </el-form-item>
          <el-form-item label="广告主ID" prop="advertiserId">
          <el-input v-model="dataForm.advertiserId" placeholder="广告主ID"></el-input>
      </el-form-item>
          <el-form-item label="微信账户APPID" prop="wechatAppid">
          <el-input v-model="dataForm.wechatAppid" placeholder="微信账户APPID"></el-input>
      </el-form-item>
          <el-form-item label="服务商ID：广点通服务商=服务商id 微信服务商=服务商spid" prop="agencyId">
          <el-input v-model="dataForm.agencyId" placeholder="服务商ID：广点通服务商=服务商id 微信服务商=服务商spid"></el-input>
      </el-form-item>
          <el-form-item label="服务商名称" prop="agencyName">
          <el-input v-model="dataForm.agencyName" placeholder="服务商名称"></el-input>
      </el-form-item>
          <el-form-item label="微信服务商id" prop="wechatSpid">
          <el-input v-model="dataForm.wechatSpid" placeholder="微信服务商id"></el-input>
      </el-form-item>
          <el-form-item label="推广计划id" prop="campaignId">
          <el-input v-model="dataForm.campaignId" placeholder="推广计划id"></el-input>
      </el-form-item>
          <el-form-item label="推广计划名称" prop="campaignName">
          <el-input v-model="dataForm.campaignName" placeholder="推广计划名称"></el-input>
      </el-form-item>
          <el-form-item label="广告组id" prop="adgroupId">
          <el-input v-model="dataForm.adgroupId" placeholder="广告组id"></el-input>
      </el-form-item>
          <el-form-item label="广告组名称" prop="adgroupName">
          <el-input v-model="dataForm.adgroupName" placeholder="广告组名称"></el-input>
      </el-form-item>
          <el-form-item label="创意ID（待废弃）" prop="creativeId">
          <el-input v-model="dataForm.creativeId" placeholder="创意ID（待废弃）"></el-input>
      </el-form-item>
          <el-form-item label="创意名称（待废弃）" prop="creativeName">
          <el-input v-model="dataForm.creativeName" placeholder="创意名称（待废弃）"></el-input>
      </el-form-item>
          <el-form-item label="广告创意ID" prop="adId">
          <el-input v-model="dataForm.adId" placeholder="广告创意ID"></el-input>
      </el-form-item>
          <el-form-item label="投放端创意ID对应的名称" prop="adName">
          <el-input v-model="dataForm.adName" placeholder="投放端创意ID对应的名称"></el-input>
      </el-form-item>
          <el-form-item label="对应mkt api 的广告创意ID" prop="adcreativeId">
          <el-input v-model="dataForm.adcreativeId" placeholder="对应mkt api 的广告创意ID"></el-input>
      </el-form-item>
          <el-form-item label="mkt api广告创意ID对应的名称" prop="adcreativeName">
          <el-input v-model="dataForm.adcreativeName" placeholder="mkt api广告创意ID对应的名称"></el-input>
      </el-form-item>
          <el-form-item label="落地页id" prop="pageId">
          <el-input v-model="dataForm.pageId" placeholder="落地页id"></el-input>
      </el-form-item>
          <el-form-item label="落地页url" prop="pageUrl">
          <el-input v-model="dataForm.pageUrl" placeholder="落地页url"></el-input>
      </el-form-item>
          <el-form-item label="线索类型" prop="leadsType">
          <el-input v-model="dataForm.leadsType" placeholder="线索类型"></el-input>
      </el-form-item>
          <el-form-item label="线索标签" prop="leadsTags">
          <el-input v-model="dataForm.leadsTags" placeholder="线索标签"></el-input>
      </el-form-item>
          <el-form-item label="线索来源" prop="leadsSource">
          <el-input v-model="dataForm.leadsSource" placeholder="线索来源"></el-input>
      </el-form-item>
          <el-form-item label="系统评分" prop="leadsPotentialScore">
          <el-input v-model="dataForm.leadsPotentialScore" placeholder="系统评分"></el-input>
      </el-form-item>
          <el-form-item label="线索接通状态" prop="leadsTouchTag">
          <el-input v-model="dataForm.leadsTouchTag" placeholder="线索接通状态"></el-input>
      </el-form-item>
          <el-form-item label="线索状态" prop="leadsFollowTag">
          <el-input v-model="dataForm.leadsFollowTag" placeholder="线索状态"></el-input>
      </el-form-item>
          <el-form-item label="号码归属地" prop="telLocation">
          <el-input v-model="dataForm.telLocation" placeholder="号码归属地"></el-input>
      </el-form-item>
          <el-form-item label="所在地" prop="leadsArea">
          <el-input v-model="dataForm.leadsArea" placeholder="所在地"></el-input>
      </el-form-item>
          <el-form-item label="邮箱" prop="leadsEmail">
          <el-input v-model="dataForm.leadsEmail" placeholder="邮箱"></el-input>
      </el-form-item>
          <el-form-item label="qq号" prop="leadsQq">
          <el-input v-model="dataForm.leadsQq" placeholder="qq号"></el-input>
      </el-form-item>
          <el-form-item label="微信号" prop="leadsWechat">
          <el-input v-model="dataForm.leadsWechat" placeholder="微信号"></el-input>
      </el-form-item>
          <el-form-item label="性别" prop="leadsGender">
          <el-input v-model="dataForm.leadsGender" placeholder="性别"></el-input>
      </el-form-item>
          <el-form-item label="国籍" prop="nationality">
          <el-input v-model="dataForm.nationality" placeholder="国籍"></el-input>
      </el-form-item>
          <el-form-item label="工作年限" prop="workingYears">
          <el-input v-model="dataForm.workingYears" placeholder="工作年限"></el-input>
      </el-form-item>
          <el-form-item label="职业" prop="profession">
          <el-input v-model="dataForm.profession" placeholder="职业"></el-input>
      </el-form-item>
          <el-form-item label="身份证号码" prop="idNumber">
          <el-input v-model="dataForm.idNumber" placeholder="身份证号码"></el-input>
      </el-form-item>
          <el-form-item label="详细地址" prop="address">
          <el-input v-model="dataForm.address" placeholder="详细地址"></el-input>
      </el-form-item>
          <el-form-item label="线索入库时间" prop="leadsCreateTime">
          <el-input v-model="dataForm.leadsCreateTime" placeholder="线索入库时间"></el-input>
      </el-form-item>
          <el-form-item label="线索提交时间" prop="leadsActionTime">
          <el-input v-model="dataForm.leadsActionTime" placeholder="线索提交时间"></el-input>
      </el-form-item>
          <el-form-item label="门店名称" prop="shopName">
          <el-input v-model="dataForm.shopName" placeholder="门店名称"></el-input>
      </el-form-item>
          <el-form-item label="门店地址" prop="shopAddress">
          <el-input v-model="dataForm.shopAddress" placeholder="门店地址"></el-input>
      </el-form-item>
          <el-form-item label="智能电话中间号" prop="callMiddleNum">
          <el-input v-model="dataForm.callMiddleNum" placeholder="智能电话中间号"></el-input>
      </el-form-item>
          <el-form-item label="智能电话-客服电话" prop="callConsumerHotline">
          <el-input v-model="dataForm.callConsumerHotline" placeholder="智能电话-客服电话"></el-input>
      </el-form-item>
          <el-form-item label="智能电话-接通状态" prop="callTouchTag">
          <el-input v-model="dataForm.callTouchTag" placeholder="智能电话-接通状态"></el-input>
      </el-form-item>
          <el-form-item label="智能电话-通话时长" prop="callDuration">
          <el-input v-model="dataForm.callDuration" placeholder="智能电话-通话时长"></el-input>
      </el-form-item>
          <el-form-item label="智能电话-通话录音链接" prop="callRecordUrl">
          <el-input v-model="dataForm.callRecordUrl" placeholder="智能电话-通话录音链接"></el-input>
      </el-form-item>
          <el-form-item label="bundle" prop="bundle">
          <el-input v-model="dataForm.bundle" placeholder="bundle"></el-input>
      </el-form-item>
              <el-form-item label="更新人" prop="updateBy">
          <el-input v-model="dataForm.updateBy" placeholder="更新人"></el-input>
      </el-form-item>
          <el-form-item label="更新日期" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="更新日期"></el-input>
      </el-form-item>
          <el-form-item label="删除日期" prop="deleteTime">
          <el-input v-model="dataForm.deleteTime" placeholder="删除日期"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        leadsName: '',
        leadsTel: '',
        age: '',
        pageName: '',
        componentId: '',
        componentName: '',
        leadsId: '',
        clickId: '',
        accountId: '',
        accountType: '',
        advertiserId: '',
        wechatAppid: '',
        agencyId: '',
        agencyName: '',
        wechatSpid: '',
        campaignId: '',
        campaignName: '',
        adgroupId: '',
        adgroupName: '',
        creativeId: '',
        creativeName: '',
        adId: '',
        adName: '',
        adcreativeId: '',
        adcreativeName: '',
        pageId: '',
        pageUrl: '',
        leadsType: '',
        leadsTags: '',
        leadsSource: '',
        leadsPotentialScore: '',
        leadsTouchTag: '',
        leadsFollowTag: '',
        telLocation: '',
        leadsArea: '',
        leadsEmail: '',
        leadsQq: '',
        leadsWechat: '',
        leadsGender: '',
        nationality: '',
        workingYears: '',
        profession: '',
        idNumber: '',
        address: '',
        leadsCreateTime: '',
        leadsActionTime: '',
        shopName: '',
        shopAddress: '',
        callMiddleNum: '',
        callConsumerHotline: '',
        callTouchTag: '',
        callDuration: '',
        callRecordUrl: '',
        bundle: '',
        creator: '',
        createDate: '',
        updateBy: '',
        updateTime: '',
        deleteTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        leadsName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        leadsTel: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        age: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pageName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        componentId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        componentName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        leadsId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        clickId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        accountId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        accountType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        advertiserId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        wechatAppid: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        agencyId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        agencyName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        wechatSpid: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        campaignId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        campaignName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        adgroupId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        adgroupName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        creativeId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        creativeName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        adId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        adName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        adcreativeId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        adcreativeName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pageId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pageUrl: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        leadsType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        leadsTags: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        leadsSource: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        leadsPotentialScore: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        leadsTouchTag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        leadsFollowTag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        telLocation: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        leadsArea: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        leadsEmail: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        leadsQq: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        leadsWechat: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        leadsGender: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        nationality: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        workingYears: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        profession: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        idNumber: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        address: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        leadsCreateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        leadsActionTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        shopName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        shopAddress: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        callMiddleNum: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        callConsumerHotline: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        callTouchTag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        callDuration: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        callRecordUrl: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bundle: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/tcustomers/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/tcustomers/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
